// extracted by mini-css-extract-plugin
export default {"slasDemoConfigDialog":"slasDemoConfigDialog-J2BkR","title":"title-s3kwy","configTab":"configTab-FjD2s"};